import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { salonService } from "../../services/salonService";

export const fetchSalons = createAsyncThunk(
  "salon/fetch",
  async (params, { rejectWithValue }) => {
    try {
      const res = await salonService.list(params);
      return res.data.data; // { content, totalElements, totalPages, number }
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Salonlar yüklenemedi");
    }
  }
);

export const createSalon = createAsyncThunk(
  "salon/create",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const res = await salonService.create(payload);
      dispatch(fetchSalons());
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Salon oluşturulamadı");
    }
  }
);

export const changeSalonStatus = createAsyncThunk(
  "salon/changeStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const res = await salonService.changeStatus(id, status);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Durum değiştirilemedi");
    }
  }
);

export const deleteSalon = createAsyncThunk(
  "salon/delete",
  async (id, { rejectWithValue }) => {
    try {
      await salonService.remove(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Salon silinemedi");
    }
  }
);

const salonSlice = createSlice({
  name: "salon",
  initialState: {
    items: [],
    totalElements: 0,
    totalPages: 0,
    page: 0,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearSalonError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSalons.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSalons.fulfilled, (state, action) => {
        const p = action.payload;
        state.isLoading = false;
        state.items = p.content ?? [];
        state.totalElements = p.totalElements ?? 0;
        state.totalPages = p.totalPages ?? 0;
        state.page = p.number ?? 0;
      })
      .addCase(fetchSalons.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // durum değişince listedeki kaydı güncelle
      .addCase(changeSalonStatus.fulfilled, (state, action) => {
        const updated = action.payload;
        const i = state.items.findIndex((s) => s.id === updated.id);
        if (i !== -1) state.items[i] = { ...state.items[i], status: updated.status };
      })
      // soft delete -> listede INACTIVE göster
      .addCase(deleteSalon.fulfilled, (state, action) => {
        const i = state.items.findIndex((s) => s.id === action.payload);
        if (i !== -1) state.items[i] = { ...state.items[i], status: "INACTIVE" };
      })
      .addCase(createSalon.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearSalonError } = salonSlice.actions;
export default salonSlice.reducer;
